export function runOnceAfterTimeout(callback: () => void, timeoutMs: number): () => void {
  let hasRun = false;
  let timeout: ReturnType<typeof setTimeout>;

  function runOnce(): void {
    if (hasRun) {
      return;
    }

    hasRun = true;
    clearTimeout(timeout);
    callback();
  }

  timeout = setTimeout(runOnce, timeoutMs);
  return runOnce;
}
